import { render, staticRenderFns } from "./BlogDate.vue?vue&type=template&id=2fdd41c6&scoped=true"
import script from "./BlogDate.vue?vue&type=script&lang=js"
export * from "./BlogDate.vue?vue&type=script&lang=js"
import style0 from "./BlogDate.vue?vue&type=style&index=0&id=2fdd41c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd41c6",
  null
  
)

export default component.exports